import React from "react";
import "./PayrollHistoryTab.scss";
import PayrollAdminHistoryTab from "../../components/PayrollAdminHistoryTab/PayrollAdminHistoryTab";
import { Box } from "@mui/material";

function PayrollHistoryTab() {
  return (
    <div className="payroll-history-container">
      {/* Header - Optional: Keep minimal or remove if new component has its own */}
      <Box sx={{ mb: 3, textAlign: "center" }}>
        <h2 style={{ margin: 0, color: "#5523D2", fontWeight: "bold" }}>
          Payroll Batch History
        </h2>
        <p style={{ color: "#666", margin: "8px 0 0" }}>
          View all your submitted payroll batches
        </p>
      </Box>

      {/* New Dedicated Component */}
      <PayrollAdminHistoryTab />
    </div>
  );
}

export default PayrollHistoryTab;